import userService from "../services/user.service";
import { STATS_FAILURE, STATS_PENDING, STATS_SUCCESS } from "./types";

export const getStats = () => async (dispatch) => {
  dispatch({ type: STATS_PENDING });

  try {
    const response = await userService.getStats();
    console.log("Stats API Response:", response.data);

    if (response.data.status && response.data.hasResult) {
      dispatch({
        type: STATS_SUCCESS,
        payload: response.data.result[0],
      });
    } else {
      dispatch({
        type: STATS_FAILURE,
        payload: "Failed to fetch stats",
      });
    }
  } catch (error) {
    dispatch({
      type: STATS_FAILURE,
      payload: error.message || "Something went wrong",
    });
  }
};
